let countriesCache = null;

async function loadCountries() {
  if (countriesCache) return countriesCache;

  try {
    const response = await fetch("/locales/countries.json");
    const data = await response.json();
    countriesCache = data;
    return countriesCache;
  } catch (err) {
    console.error("Error loading countries:", err);
    return [];
  }
}

/**
 * Devuelve el nombre del país según alpha2 y el idioma actual.
 * @param {string} alpha2 Código ISO del país
 * @param {string} language Idioma actual ('es' o 'en')
 * @returns {Promise<string>} Label del país
 */
export async function getCountryLabel(alpha2, language = "en") {
  if (!alpha2) return "";

  const countries = await loadCountries();
  const found = countries.find(
    (c) => c.alpha2.toLowerCase() === alpha2.toLowerCase()
  );

  if (!found) return alpha2;
  return language === "es" ? found.label_es.toString() : found.label_en.toString();
}